// @flow
import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import EventNoteIcon from "@material-ui/icons/EventNote";

import { CopyRight } from "../../global/components/CopyRight";

const Transition = (props): React$Element<*> => (
  <Slide direction="down" {...props} />
);

type TermsPropsType = {
  open: boolean,
  handleModalStatus: Function,
  CheckTerms?: Function
};

class Terms extends React.Component<TermsPropsType, *> {
  handleClickOpen = () => {
    this.props.handleModalStatus(true);
  };

  handleRequestClose = () => {
    this.props.handleModalStatus(false);
  };

  CheckTerms = () => {
    this.props.CheckTerms && this.props.CheckTerms();
    this.handleRequestClose();
  };

  render(): * {
    return (
      <Dialog
        disableBackdropClick
        maxWidth="md"
        open={this.props.open}
        onClose={this.handleRequestClose}
        TransitionComponent={Transition}
      >
        <AppBar position="absolute" color="primary">
          <Toolbar>
            <IconButton
              color="inherit"
              onClick={this.handleRequestClose}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" color="inherit">
              Terms And Conditions
            </Typography>
            <EventNoteIcon className="left-margin-5" />
          </Toolbar>
        </AppBar>
        <div className="mui-form">
          <div className="terms-block green-title inner-wrapper">
            <span className="header">Terms and Conditions</span>
            <br />
            <br />
            <span className="title">Last Updated: 10 Dec 2019</span>
            <br />
            <br />
            The following Terms and Conditions govern all use of the{" "}
            <b>apps.imagus.com.au</b> website and service. The website is owned
            and operated by Vix Vizion Pty Ltd. (“Vix Vizion”). The website is
            offered subject to your acceptance without modification of all the
            terms contained herein and all other operating rules, policies and
            procedures that may be published from time to time on this site by
            Vix Vizion (collectively, the “agreement”).
            <br />
            <br />
            Please read this agreement carefully before accessing or using the
            website. By accessing or using any part of the website, you agree to
            become bound by the terms of this agreement. If you do not agree to
            all the terms of this agreement, then you may not access the website
            or use any services. If these terms and conditions are considered an
            offer by Vix Vizion, acceptance is expressly limited to these terms.
            The website is available only to individuals who are at least 13
            years old.
            <br />
            <br />
            <span className="title">Your Vix Vizion Web Interface account</span>
            <br />
            You are responsible for maintaining the security of your account,
            and you are fully responsible for all activities that occur under
            the account and any other actions taken in connection with the
            account. You must immediately notify Vix Vizion of any unauthorized
            use of your account or any other breaches of security. Vix Vizion
            will not be liable for any acts or omissions by You, including any
            damages of any kind incurred as a result of such acts or omissions.
            <br />
            <br />
            <span className="title">Renewal and Extension</span>
            <br />
            If you wish to keep using the service after the 30-day free trial
            period ends, please contact Vix Vizion to renew or extend the trial
            period. Your account can be cancelled at any time.
            <br />
            <br />
            <span className="title">Intellectual Property</span>
            <br />
            This agreement does not transfer from Vix Vizion to you any Vix
            Vizion or third party intellectual property, and all right, title
            and interest in and to such property will remain (as between the
            parties) solely with Vix Vizion. Vix Vizion, apps.imagus.com.au, the
            Vix Vizion logo, and all other trademarks, service marks, graphics
            and logos used in connection with apps.imagus.com.au, or the website
            are trademarks or registered trademarks of Vix Vizion or Vix
            Vizion’s licensors. Other trademarks, service marks, graphics and
            logos used in connection with the website may be the trademarks of
            other third parties. Your use of the website grants you no right or
            license to reproduce or otherwise use any Vix Vizion or third-party
            trademarks.
            <br />
            <br />
            <span className="title">Changes</span>
            <br />
            Vix Vizion reserves the right, at its sole discretion, to modify or
            replace any part of these terms and conditions. It is your
            responsibility to check this agreement periodically for changes.
            Your continued use of or access to the website following the posting
            of any changes to this agreement constitutes acceptance of those
            changes. Vix Vizion may also, in the future, offer new services
            and/or features through the website (including, the release of new
            tools and resources). Such new features and/or services shall be
            subject to the terms and conditions of this agreement.
            <br />
            <br />
            <span className="title">Termination</span>
            <br />
            Vix Vizion may terminate your access to all or any part of the
            website at any time, with or without cause, with or without notice,
            effective immediately. All provisions of this agreement which by
            their nature should survive termination shall survive termination,
            including, without limitation, ownership provisions, warranty
            disclaimers, indemnity and limitations of liability.
            <br />
            <br />
            <span className="title">Disclaimer of Warranties</span>
            <br />
            The website is provided “as is”. Vix Vizion and its suppliers and
            licensors to the fullest extent permissible by law hereby disclaim
            all warranties of any kind, express or implied, including, without
            limitation, the warranties of merchantability, fitness for a
            particular purpose and non-infringement. Neither Vix Vizion nor its
            suppliers and licensors, makes any warranty that the website will be
            error free or that access thereto will be continuous or
            uninterrupted. You understand that you download from, or otherwise
            obtain content or services through, the website at your own
            discretion and risk.
            <br />
            <br />
            <span className="title">Limitation of Liability</span>
            <br />
            <span className="title">
              TO THE FULLEST EXTENT PERMITTED BY LAW VIX VIZION, OR ITS
              SUPPLIERS OR LICENSORS, WILL NOT BE LIABLE WITH RESPECT TO ANY
              SUBJECT MATTER OF THIS AGREEMENT UNDER ANY CONTRACT, NEGLIGENCE,
              STRICT LIABILITY OR OTHER LEGAL OR EQUITABLE THEORY FOR: (I) ANY
              SPECIAL, INCIDENTAL OR CONSEQUENTIAL DAMAGES INCLUDING WITHOUT
              LIMITATION LOSS Of PROFITS, LOSS OF DATA OR ANY LOSS OF ANY TYPE
              OF OPPORTUNITY WHETHER FINANCIAL OR OTHERWISE; (II) THE COST OF
              PROCUREMENT FOR SUBSTITUTE PRODUCTS OR SERVICES; (III) FOR
              INTERRUPTION OF USE OR LOSS OR CORRUPTION OF DATA; OR (IV) FOR ANY
              AMOUNTS THAT EXCEED THE FEES PAID BY YOU TO VIX VIZION UNDER THIS
              AGREEMENT DURING THE TWELVE (12) MONTH PERIOD PRIOR TO THE CAUSE
              OF ACTION. VIX VIZION SHALL HAVE NO LIABILITY FOR ANY FAILURE OR
              DELAY DUE TO MATTERS BEYOND THEIR REASONABLE CONTROL. THE
              FOREGOING SHALL NOT APPLY TO THE EXTENT PROHIBITED BY APPLICABLE
              LAW.
            </span>
            <br />
            <br />
            <br />
            <span className="title">Privacy Policy</span>
            <br />
            This section informs you of our policies regarding the collection,
            use and disclosure of Personal Information when you use our Service.
            <br />
            <br />
            We will not use or share your information with anyone except as
            described in this Privacy Policy.
            <br />
            <br />
            We use your Personal Information for providing and improving the
            Service. By using the Service, you agree to the collection and use
            of information in accordance with this policy.
            <br />
            <br />
            <span className="sub-title">Information Collection And Use</span>
            <br />
            While using our Service, we may ask you to provide us with certain
            Personally Identifiable Information via your browser (e.g. via
            cookies) for our use only or for a purpose to which you are informed
            of at the time of collecting the personal information about you.
            Personally Identifiable Information may include, but is not limited
            to, your name, email address, image, other information (“Personal
            Information”).
            <br />
            <br />
            <span className="sub-title">Log Data</span>
            <br />
            We collect information that your browser sends whenever you visit
            our Service (“Log Data”). This Log Data may include information such
            as your computer’s Internet Protocol (“IP”) address, browser type,
            browser version, the pages of our Service that you visit, the time
            and date of your visit, the time spent on those pages and other
            statistics.
            <br />
            <br />
            <span className="sub-title">Cookies</span>
            <br />
            Cookies are files with small amount of data, which may include an
            anonymous unique identifier. Cookies are sent to your browser from a
            web site and stored on your computer’s hard drive.
            <br />
            <br />
            We use “cookies” to identify unique users across browsing sessions.
            You can instruct your browser to refuse all cookies or to indicate
            when a cookie is being sent. However, if you do not accept cookies,
            you may not be able to use some portions of our Service.
            <br />
            <br />
            <span className="sub-title">Service Providers</span>
            <br />
            We may employ third party companies and individuals to facilitate
            our Service, to provide the Service on our behalf, to perform
            Service-related services or to assist us in analysing how our
            Service is used.
            <br />
            <br />
            These third parties have access to your Personal Information only to
            perform these tasks on our behalf and are obligated not to disclose
            or use it for any other purpose.
            <br />
            <br />
            <span className="sub-title">Security</span>
            <br />
            The security of your Personal Information is important to us, but
            remember that no method of transmission over the internet, or method
            of electronic storage is 100% secure. While we strive to use
            commercially acceptable means to protect your Personal Information,
            we cannot guarantee its absolute security.
            <br />
            <br />
            <span className="sub-title">Link to Other Sites</span>
            <br />
            Our Service may contain links to other sites that are not operated
            by us. If you click on a third-party link, you will be directed to
            that third party’s site. We strongly advise you to review the
            Privacy Policy of every site you visit.
            <br />
            <br />
            We have no control over, and assume no responsibility for the
            content, privacy policies or practices of any third-party sites or
            services.
            <br />
            <br />
            <span className="sub-title">Changes To This Privacy Policy</span>
            <br />
            We may update our Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page.
            <br />
            <br />
            <br />
            <span className="title">General Representation and Warranty</span>
            <br />
            You represent and warrant that (i) your use of the website will be
            in strict accordance with the Vix Vizion
            <span className="sub-title">Privacy Policy</span>, with this
            agreement and with all applicable laws and regulations (including
            without limitation any local laws or regulations in your country,
            state, city, or other governmental area, regarding online conduct
            and acceptable content, and including all applicable laws regarding
            the transmission of technical data exported from the country in
            which you reside) and (ii) your use of the website will not infringe
            or misappropriate the intellectual property rights of any third
            party.
            <br />
            <br />
            <span className="title">Indemnification</span>
            <br />
            You agree to indemnify and hold harmless Vix Vizion, its
            contractors, and its licensors, and their respective directors,
            officers, employees and agents from and against any and all claims
            and expenses, including attorneys’ fees, arising out of your use of
            the website, including but not limited to your violation of this
            agreement.
            <br />
            <br />
            <span className="title">Miscellaneous</span>
            <br />
            This agreement constitutes the entire agreement between Vix Vizion
            and you concerning the subject matter hereof, and they may only be
            modified by a written amendment signed by an authorized executive of
            Vix Vizion, or by the posting by Vix Vizion of a revised version. A
            waiver by either party of any term or condition of this agreement or
            any breach thereof, in any one instance, will not waive such term or
            condition or any subsequent breach thereof. You may assign your
            rights under this agreement to any party that consents to, and
            agrees to be bound by, its terms and conditions; Vix Vizion may
            assign its rights under this agreement without condition. This
            agreement will be binding upon and will inure to the benefit of the
            parties, their successors and permitted assigns.
            <br />
            <br />
            <br />
            <span className="title">Vix Vizion Pty Ltd</span>
            <br />
            Our mailing address:
            <br />
            Suite 18, 76 Brunswick Street,
            <br />
            Fortitude Valley QLD 4006
            <br />
            <br />
            {this.props.CheckTerms && (
              <Button
                color="primary"
                variant="contained"
                type="button"
                id="submitBtn"
                className="primary-btn"
                style={{ width: "100%" }}
                onClick={this.CheckTerms}
              >
                Accept
              </Button>
            )}
            <Typography
              variant="subtitle1"
              className="green-title form-text fixed-bottom"
            >
              <span className="">{CopyRight}</span>
            </Typography>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default Terms;
